/* eslint-disable react/prop-types */
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Row,
  Spin,
} from 'antd';
import Password from 'components/Password';
import React from 'react';

const UsuariosContrasena = ({
  form,
  loading,
  rules,
  onValuesChange,
  options,
  selectedRowKeys,
  visiblePwd,
  setVisiblePwd,
  disableEditar,
}) => (
  <Row className="container">
    <Spin tip="Cargando..." spinning={loading}>
      {!selectedRowKeys.length ? (
        <Form
          layout="vertical"
          form={form}
          scrollToFirstError
          name="contrasena"
          onValuesChange={onValuesChange}
        >
          <Password
            rules={rules}
            options={options}
          />
        </Form>
      ) : (
        <>
          <Col xs={24} sm={24} md={24}>
            <Button
              onClick={() => setVisiblePwd(!visiblePwd)}
              className="no-color primary-on-hover"
              style={{ borderRadius: 6, marginBottom: 10, marginTop: 10 }}
              disabled={disableEditar}
            >
              Cambiar Contraseña
              {!visiblePwd ? (<DownOutlined />) : (<UpOutlined />)}
            </Button>
          </Col>
          {visiblePwd && (
            <Form
              layout="vertical"
              form={form}
              scrollToFirstError
              name="contrasena"
              onValuesChange={onValuesChange}
            >
              <Password
                rules={rules}
                options={options}
              />
            </Form>
          )}
        </>
      )}
    </Spin>
  </Row>
);

export default UsuariosContrasena;
